<fab-loading-spinner [hidden]="(!showSpinner)" color="primary"></fab-loading-spinner>
<div id="header-container">
  <h2 id="header-text">Update Propulsion Scenario with Propulsion Portfolio</h2>
  <div id="actions-container">
    <button mat-stroked-button id="cancel-button" class="action-button" (click)="onCancel()">Cancel</button>
    <button mat-raised-button color="primary" id="add-button" class="action-button"
            (click)="onConfirm()">
      Confirm
    </button>
  </div>
</div>
<div mat-dialog-content>
  <div class="checkbox-float">
    <mat-checkbox [(ngModel)]="checkboxValue"
                  (change)="onCheckboxChange()">
      Remove Unmatched Records with Penetrations within CY START YYYY and CY END YYYY
    </mat-checkbox>
    <ng-container *ngIf="checkboxValue">
      <p>To update the Propulsion portfolio and preserve historical and short term data in a Propulsion scenario,
        please specify a range of dates where unmatched records can be deleted.
      </p>
      <br/>
      <h4>
        <b>Full Description:</b>
      </h4>
      <p>
        For records in PROP scenario with penetrations solely within the CY Start and CY End range but unmatched to PROP
        portfolio, remove from PROP scenario. Unmatched records with penetrations outside of CY Start and CY End range
        remain in scenario.
      </p>
    </ng-container>
    <ng-container *ngIf="checkboxValue">
      <mat-form-field class="filter-options">
        <mat-label class="asterisk--before">Start Year</mat-label>
        <mat-select [(ngModel)]="selectedStartYear" id="startYear">
          <mat-option *ngFor="let year of scenarioYearRange" [value]="year">{{year}}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="filter-options">
        <mat-label class="asterisk--before">End Year</mat-label>
        <mat-select [(ngModel)]="selectedEndYear" id="endYear">
          <mat-option *ngFor="let year of scenarioYearRange" [value]="year">{{year}}</mat-option>
        </mat-select>
      </mat-form-field>
    </ng-container>
  </div>
</div>
